import { InvoiceFromOcrDto } from "@/api/invoiceApi";
import { ocrBankAccountType } from "@/utils/invoiceUtils";

/**
 * Derives a bank account object from OCR response if both bankAccount and currency are present.
 * Returns undefined if either field is missing.
 */
export const toOcrBankAccount = (ocrResponse?: InvoiceFromOcrDto): ocrBankAccountType | undefined => {
    return ocrResponse && (ocrResponse.bankAccount || ocrResponse.currency)
        ? { accountNumber: ocrResponse.bankAccount, currency: ocrResponse.currency }
        : undefined;
};
